import React from 'react';
import PropTypes from 'prop-types';
import { FormTextarea } from '@getro/rombo';

export const LongTextField = ({ field, value, onChange, onBlur, error, disabled }) => {
  const fieldName = field.id?.toString() || field.tempId;

  return (
    <FormTextarea
      label={field.label}
      labelExtra={field.required ? 'Required' : ''}
      rows={5}
      disabled={disabled}
      helpText={field.helperText}
      field={{
        name: fieldName,
        value,
        onChange,
        onBlur,
      }}
      form={{
        errors: { [fieldName]: error },
        touched: { [fieldName]: !!error },
      }}
    />
  );
};

LongTextField.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tempId: PropTypes.string,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired,
    helperText: PropTypes.string,
  }).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  error: PropTypes.string,
  disabled: PropTypes.bool,
};

LongTextField.defaultProps = {
  value: '',
  onChange: undefined,
  onBlur: undefined,
  error: undefined,
  disabled: false,
};
